module.exports = __webpack_public_path__ + "static/media/2playerRoomsPlayed_250000_500000.aef0303d.png";